module.exports = __webpack_public_path__ + "img/2.8b8cf1a3.jpg";